export default {
    'name': 'burger',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M3 4.5C2.58579 4.5 2.25 4.83579 2.25 5.25C2.25 5.66421 2.58579 6 3 6H20.875C21.2892 6 21.625 5.66421 21.625 5.25C21.625 4.83579 21.2892 4.5 20.875 4.5H3ZM3 11C2.58579 11 2.25 11.3358 2.25 11.75C2.25 12.1642 2.58579 12.5 3 12.5H20.875C21.2892 12.5 21.625 12.1642 21.625 11.75C21.625 11.3358 21.2892 11 20.875 11H3ZM2.25 18.25C2.25 17.8358 2.58579 17.5 3 17.5H20.875C21.2892 17.5 21.625 17.8358 21.625 18.25C21.625 18.6642 21.2892 19 20.875 19H3C2.58579 19 2.25 18.6642 2.25 18.25Z\' fill=\'#026958\'/>'
}
